//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { queryFollowFund, queryCustomFund, queryLcSearchList, searchProListByType, fetchOldFund, fetchNewFund } from '@/service/service'
import { setTimeout } from 'timers'
import filters from '@/filters/filters'
export default {
	data() {
		return {
			navList: [
				{
					id: '1',
					show: true,
					text: '我的收藏',
					data: [
						{
							type: 'all',
							text: '自选基金',
						},
					],
				},
				{
					id: '2',
					show: true,
					text: '理财',
					data: [
						{
							type: 'all',
							text: '全部',
						},
						{
							type: '1',
							text: '固定收益',
						},
						{
							type: '2',
							text: '浮动收益',
						},
					],
				},
				{
					id: '3',
					show: true,
					text: '基金',
					data: [
						{
							type: 'all',
							text: '全部',
						},
						{
							type: '1',
							text: '股票型',
						},
						{
							type: '2',
							text: '混合型',
						},
						{
							type: '3',
							text: '债券型',
						},
						{
							type: '6',
							text: '货币型',
						},
						{
							type: '5',
							text: '保本型',
						},
						{
							type: '7',
							text: '分级基金',
						},
						{
							type: 'zs',
							text: '指数型',
						},
						{
							type: 'lc',
							text: '理财型',
						},
						{
							type: '21',
							text: 'QDII',
						},
						{
							type: '99',
							text: '养老型',
						},
						{
							type: '100',
							text: '新发基金',
						},
					],
				},
			],
			fundfilter: [
				{
					id: '1',
					text: '风险等级',
					data: [
						{
							type: '0',
							text: '不限',
						},
						{
							type: '1',
							text: 'R1',
						},
						{
							type: '2',
							text: 'R2',
						},
						{
							type: '3',
							text: 'R3',
						},
						{
							type: '4',
							text: 'R4',
						},
						{
							type: '5',
							text: 'R5',
						},
					],
				},
				{
					id: '2',
					text: '起购金额',
					data: [
						{
							type: '0',
							text: '不限',
						},
						{
							type: '1',
							text: '1元起',
						},
						{
							type: '10',
							text: '10元起',
						},
						{
							type: '100',
							text: '100元起',
						},
						{
							type: '1000',
							text: '1000元起',
						},
					],
				},
				{
					id: '3',
					text: '产品评级',
					data: [
						{
							type: '0',
							text: '不限',
						},
						{
							type: '3',
							text: '三星',
						},
						{
							type: '4',
							text: '四星',
						},
						{
							type: '5',
							text: '五星',
						},
					],
				},
			],
			finafilter: [
				{
					id: '1',
					text: '风险等级',
					data: [
						{
							type: '0',
							text: '不限',
						},
						{
							type: '1',
							text: 'R1',
						},
						{
							type: '2',
							text: 'R2',
						},
						{
							type: '3',
							text: 'R3',
						},
						{
							type: '4',
							text: 'R4',
						},
						{
							type: '5',
							text: 'R5',
						},
					],
				},
				{
					id: '2',
					text: '期限',
					data: [
						{
							type: '0',
							text: '不限',
						},
						{
							type: '90',
							text: '0-3月',
						},
						{
							type: '90%2c365',
							text: '3-12月',
						},
						{
							type: '365',
							text: '12月以上',
						},
						{
							text: '灵活不定期',
							type: 'flexible',
						},
					],
				},
				{
					id: '3',
					text: '起购金额',
					data: [
						{
							type: '0',
							text: '不限',
						},
						{
							type: '50000',
							text: '5万起',
						},
						{
							type: '100000',
							text: '10万起',
						},
						{
							type: '1000000',
							text: '100万起',
						},
						{
							type: '10000000',
							text: '1000万起',
						},
					],
				},
			],
			proList: [],
			currentPage: 1,
			currId: '1',
			currType: 'all',
			rowsNum: '10',
			currCate: '0',
			currLevel: '0',
			currStart: '0',
			currStar: '0',
			currTime: '0',
			searchText: '',
			searchArr: [],
			searchActive: false,
		}
	},
	methods: {
		getFollowList() {
			let fundcode = ''
			for (let i = 0; i < this.$store.state.follow.length; i++) {
				fundcode += this.$store.state.follow[i].split('|')[0] + ','
			}
			let data = {
				fundcode: fundcode,
				filterfx: '5',
			}
			queryFollowFund(data).then((resultVo) => {
				let focusResults = resultVo.results
				let focusList = []
				for (let i = 0; i < this.$store.state.follow.length; i++) {
					let fundcode = this.$store.state.follow[i].split('|')[0]
					let fundalias = this.$store.state.follow[i].split('|')[1]

					let sub_data = {}
					sub_data.key = i
					sub_data.fund_code = fundcode
					sub_data.fund_alias = fundalias

					let sub_fund_code = '--'
					// let sub_fund_alias = '--'
					let sub_daten = '--'
					let sub_navgrowthcalctype = '--'
					let sub_yield = '--'
					let sub_nav = '--'
					let sub_gain = '--'
					// sub_data.fund_alias = sub_fund_alias
					sub_data.daten = sub_daten
					sub_data.navgrowthcalctype = sub_navgrowthcalctype
					sub_data.yield = sub_yield
					sub_data.nav = sub_nav
					sub_data.gain = sub_gain
					for (let j = 0; j < focusResults.length; j++) {
						sub_fund_code = focusResults[j].fund_code
						if (fundcode && fundcode == sub_fund_code) {
							sub_data.daten = focusResults[j].daten
							sub_data.navgrowthcalctype = focusResults[j].navgrowthcalctype
							sub_data.yield = focusResults[j].yield
							sub_data.nav = focusResults[j].nav
							sub_data.gain = focusResults[j].gain
							// sub_data.push(focusResults[j]);
						}
					}
					focusList.push(sub_data)
				}
				this.proList = focusList
			})
		},
		getCustomFund(type) {
			let data = {
				type: type == 'all' ? '' : type,
				rows: this.rowsNum,
				fxdj: this.currLevel == '0' ? '' : this.currLevel,
				rgqd: this.currStart == '0' ? '' : this.currStart,
				xj: this.currStar == '0' ? '' : this.currStar,
				keyword: this.searchText.toUpperCase(),
				pageId: 'fundlist',
				sort: type == '6' || type == 'lc' ? 'yield' : 'gain',
				currentPage: this.currentPage,
				filterfx: '5',
				isCanBuy: true,
			}
			queryCustomFund(data).then((resultVo) => {
				if (this.currentPage == 1) {
					this.proList = resultVo.DataSet0
					for (var i in this.proList) {
						this.proList[i].fxdj_text = this.constants.OPENFUND_FXDJ[this.proList[i].fxdj]
					}
				} else if (this.currentPage > 1) {
					this.proList = this.proList.concat(resultVo.DataSet0)
					for (var i in this.proList) {
						this.proList[i].fxdj_text = this.constants.OPENFUND_FXDJ[this.proList[i].fxdj]
					}
				} else if (this.currentPage > 1) {
					return false
				}
			})
		},
		getLcSearchList(type) {
			let data = {
				type: type,
				pageCode: this.currCate == '0' ? 'sy_all' : this.currCate,
				rgqd: this.currStart == '0' ? '' : this.currStart,
				fxdj: this.currLevel == '0' ? '' : this.currLevel,
				qx: this.currTime == '0' || this.currCate == 'sy_jz' ? '' : this.currTime,
				keyword: this.searchText.toUpperCase(),
				currentPage: this.currentPage,
				rows: this.rowsNum,
				filterfx: '5',
			}
			queryLcSearchList(data).then((resultVo) => {
				if (this.currentPage == 1) {
					this.proList = this.formatFina(resultVo.DataSet0)
				} else if (this.currentPage > 1) {
					console.log(this.formatFina(resultVo.DataSet0))
					this.proList = this.proList.concat(this.formatFina(resultVo.DataSet0))
				} else if (this.currentPage > 1) {
					return false
				}
			})
		},
		fetchNewFund() {
			let data = {
				type: '2',
				rows: this.rowsNum,
				fxdj: this.currLevel == '0' ? '' : this.currLevel,
				rgqd: this.currStart == '0' ? '' : this.currStart,
				keyword: this.searchText.toUpperCase(),
				pageId: 'fundlist',
				currentPage: this.currentPage,
				filterfx: '5',
			}
			fetchNewFund(data).then((resultVo) => {
				if (this.currentPage == 1) {
					this.proList = this.formatFina(resultVo.results)
				} else if (this.currentPage > 1) {
					console.log(this.formatFina(resultVo.results))
					this.proList = this.proList.concat(this.formatFina(resultVo.results))
				} else if (this.currentPage > 1) {
					return false
				}
			})
		},
		fetchOldFund() {
			let data = {
				rgqd: this.currStart == '0' ? '' : this.currStart,
				fxdj: this.currLevel == '0' ? '' : this.currLevel,
				htpj: this.currStar == '0' ? '' : this.currStar,
			}
			fetchOldFund(data).then((resultVo) => {
				if (this.currentPage == 1) {
					this.proList = this.formatFina(resultVo.DataSet0)
				} else if (this.currentPage > 1) {
					console.log(this.formatFina(resultVo.DataSet0))
					this.proList = this.proList.concat(this.formatFina(resultVo.DataSet0))
				} else if (this.currentPage > 1) {
					return false
				}
			})
		},
		formatFina(data) {
			for (var i in data) {
				if (data[i].es_tycpfl == this.constants.ES_TYCPFL.ZG) {
					data[i].qg_text = parseFloat(data[i].grscsgzdje / 10000) + '万起'
				} else {
					data[i].qg_text = data[i].rgqd + '万起'
				}

				if ((this.constants.ES_CPFLBM.NXB == data[i].es_cpflbm || this.constants.ES_CPFLBM.HJB == data[i].es_cpflbm) && data[i].sylsx) {
					data[i].syl_text = data[i].sylxx + '% 或 ' + data[i].sylsx + '%'
				} else if (this.constants.ES_CPFLBM.ZSB == data[i].es_cpflbm && data[i].sylsx) {
					data[i].syl_text = data[i].sylxx + '% ~ ' + data[i].sylsx + '%'
				} else {
					if (data[i].es_tycpfl_zg && data[i].es_tycpfl_zg == this.constants.ES_TYCPFL_ZG.LC) {
						data[i].syl_text = data[i].syl ? parseFloat(data[i].syl).toFixed(3) + '%' : '--%'
					} else {
						data[i].syl_text = data[i].syl ? data[i].syl + '%' : '--%'
					}
				}

				if (data[i].es_tycpfl == this.constants.ES_TYCPFL.ZG) {
					if (data[i].es_tycpfl_zg == this.constants.ES_TYCPFL_ZG.LC) {
						data[i].syl_text = data[i].syl_text
					} else {
						data[i].syl_text = parseFloat(data[i].cpjz).toFixed(4)
					}
				} else {
					data[i].syl_text = data[i].syl_text
				}

				data[i].fxdj_text = this.constants.OPENFUND_FXDJ[data[i].fxdj]

				if (data[i].es_tycpfl && data[i].es_tycpfl == this.constants.ES_TYCPFL.ZG) {
					if (data[i].es_tycpfl_zg == this.constants.ES_TYCPFL_ZG.JZ) {
						data[i].cpqx_text = '<span>' + filters.dateFormat(data[i].jzrq, 'MM-dd') + '</span><span class="block">净值日期</span>'
					} else {
						data[i].cpqx_text = data[i].cpqx
					}
				} else {
					data[i].cpqx_text = data[i].cpqx
				}

				if (data[i].es_tycpfl && data[i].es_tycpfl == this.constants.ES_TYCPFL.ZG) {
					data[i].isneedlogin = false
				} else {
					data[i].isneedlogin = true
				}
			}

			return data
		},
		navChange(id, type) {
			sessionStorage.setItem('filter', id + '|' + type)
			this.currId = id
			this.currType = type == 'all' ? '' : type
			this.currLevel = '0'
			this.currTime = '0'
			this.currStart = '0'
			this.currStar = '0'
			this.currentPage = '1'
			this.searchText = ''
			this.proList = []
			if (id == '2' && type != 'all') {
				if (type == '1') {
					this.currCate = 'sy_lc'
				} else if (type == '2') {
					this.currCate = 'sy_jz'
				} else {
					this.currCate = '0'
				}
			}

			this.chngeList()

			this.$nextTick(function () {
				if (this.$refs.main.scrollTop > 0) {
					this.$refs.main.scrollTop = 0
				}
			})
		},
		chngeList() {
			if (this.currId == '1') {
				this.getFollowList()
			} else if (this.currId == '2') {
				this.getLcSearchList(this.currType)
			} else if (this.currId == '3') {
				if (this.currType == '99') {
					this.fetchOldFund()
				} else if (this.currType == '100') {
					this.fetchNewFund()
				} else {
					this.getCustomFund(this.currType)
				}
			}
		},
		resetList() {
			this.currentPage = '1'
			this.proList = []
			this.chngeList()
			this.$refs.main.scrollTo(0, 0)
		},
		changeCate(type) {
			this.currCate = type
			this.resetList()
		},
		changeLevel(type) {
			this.currLevel = type
			this.resetList()
		},
		changeTime(type) {
			this.currTime = type
			this.resetList()
		},
		changeStart(type) {
			this.currStart = type
			this.resetList()
		},
		changeStar(type) {
			this.currStar = type
			this.resetList()
		},
		changeShow(id) {
			this.navList[id - 1].show = this.navList[id - 1].show == true ? false : true
		},
		changePage() {
			this.currentPage = parseInt(this.currentPage) + 1
		},
		inputFocus() {},
		inputBlur() {},
		formatSearchData(data) {
			console.log(data)
		},
		highlight(value, key) {
			if (value.indexOf(key) != -1) {
				return value.replace(key, '<em>' + key + '</em>')
			} else {
				return value
			}
		},
		goMore(id) {
			if (id == '1fund') {
				this.$router.push({
					path: '/product',
					query: {
						id: '3',
					},
				})
			} else {
				this.$router.push({
					path: '/product',
					query: {
						id: '2',
					},
				})
			}
		},
		topage(item) {
			if (item.path) {
				let path = item.path
				let name = ''
				if (item.path == '/') {
					name = '主页'
				} else if (item.path == '/product') {
					name = '产品列表'
				} else if (item.path == '/news') {
					name = '理财资讯'
				}
				if (window.qt) {
					try {
						window.QtSubmit.JSICallMethod('ehtsec://nativeLog?event=tabView&openType=理财&tab=' + name)
					} catch (e) {
						console.log(e)
					}
				}
				this.$router.push(path)
			}
		},
	},
	created() {
		this.$nextTick(function () {
			var _this = this
			var scrollmain = this.$refs.main
			scrollmain.addEventListener('scroll', function () {
				var scrollTop = this.scrollTop
				var finished = true
				_this.$refs.thead.style.transform = 'translateY(' + scrollTop + 'px)'
				if (finished && this.scrollHeight - this.clientHeight == this.scrollTop) {
					finished = false
					_this.changePage()
					_this.chngeList()
				}
			})
		})
	},
	mounted() {
		this.rowsNum = parseInt(this.$refs.main.clientHeight / 34) + 1
		let $this = this
		window.onresize = function () {
			if ($this.$refs.main != undefined) {
				$this.rowsNum = parseInt($this.$refs.main.clientHeight / 34) + 1
			}
		}
		var filter = sessionStorage.getItem('filter')
		if (this.$route.query.search_type) {
			if (this.$route.query.search_field) {
				this.currId = this.$route.query.search_type
				this.searchText = this.$route.query.search_field
			} else {
				this.currId = this.$route.query.search_type
				this.currType = 'all'
			}
			if (this.$route.query.search_cate) {
				this.currType = this.$route.query.search_cate
			}
			if (this.$route.query.search_sort) {
				this.currTime = this.$route.query.search_sort
			}
		} else if (filter && filter.split('|')[0] && filter.split('|')[1]) {
			this.currId = filter.split('|')[0]
			this.currType = filter.split('|')[1]
			if (this.currId == '2' && this.currType != '0') {
				if (this.currType == '1') {
					this.currCate = 'sy_lc'
				} else if (this.currType == '2') {
					this.currCate = 'sy_jz'
				} else {
					this.currCate = '0'
				}
			}
		} else {
			this.currId = '1'
			this.currType = 'all'
		}
		this.chngeList()
	},
	watch: {
		searchText(value, oldvalue) {
			this.currentPage = '1'
			this.chngeList()
			this.$refs.main.scrollTo(0, 0)
		},
	},
	filters: {
		formateValue(value) {
			return parseInt(value).toFixed(2) + '元起投'
		},
		statusFormat(value) {
			if (value == '0') {
				return '在售'
			} else if (value == '1') {
				return '预售'
			} else if (value == '1') {
				return '结束'
			} else {
				return '--'
			}
		},
	},
}



// WEBPACK FOOTER //
// ./src/pages/prolist.vue